<!--  -->
<template>
  <div>
    <app-panel
      :title="deviceTitle"
      :isExpand="showIntercomList"
      :transparent="isTransparent"
      :modal="false"
      @cancel="closeAudioDialog"
      :width="350"
    >
      <div class="broadcast-intercom-table">
        <!--远程喊话--话筒-->
        <div class="table_content">
          <div style="height: 100%" v-if="isType == 1 || isType == 2">
            <div class="table_search">
              <el-input
                clearable
                :placeholder="panelPlaceholder"
                v-model="filterText"
              ></el-input>
            </div>
            <el-scrollbar style="height: calc(100% - 60px)">
              <!-- 话筒tree -->
              <el-tree
                v-if="isType == 1"
                ref="panelDeviceTree"
                :data="sourceData"
                highlight-current
                :default-expanded-keys="expandedKeys"
                node-key="id"
                :props="treeProps"
                @node-click="nodeClick"
                :default-expand-all="true"
                :filter-node-method="filterNode"
              >
                <div
                  slot-scope="{ data }"
                  :title="'话筒：' + data.name"
                  class="showOverText"
                  style="width: 100%"
                >
                  <i
                    v-if="data.nodeType === 'device'"
                    class="el-icon-microphone"
                  ></i>
                  <span style="margin-left: 5px">{{ data.name }}</span>
                </div>
              </el-tree>
              <!-- 广播tree -->
              <!--  -->
              <div
                style="color: gray; padding: 0px 12px 10px"
                v-if="isType == 2"
              >
                <p>
                  提示：
                  非广播设备数据和正在被广播喊话/音频播放中的设备禁止被选中
                </p>
              </div>
              <el-tree
                v-if="isType == 2"
                ref="panelDeviceTree"
                :data="sourceData"
                show-checkbox
                highlight-current
                check-on-click-node
                :default-expanded-keys="expandedKeys"
                node-key="id"
                @check-change="nodeCheck"
                :props="gbProps"
                :default-expand-all="true"
                :filter-node-method="filterNode"
              >
                <div
                  slot-scope="{ data }"
                  :title="'广播：' + data.name"
                  class="showOverText"
                  style="width: 100%"
                >
                  <i
                    v-show="data.nodeType === 'device'"
                    class="iconfont-lunan icon-lunan-guangbo"
                  ></i>
                  <span style="margin-left: 5px">{{ data.name }}</span>
                </div>
              </el-tree>
            </el-scrollbar>
          </div>
          <!--播放音频-->
          <div style="height: 100%" v-if="isType == 3">
            <div class="table_search">
              <el-input
                clearable
                :placeholder="panelPlaceholder"
                v-model="audioName"
              ></el-input>
            </div>
            <el-scrollbar style="height: calc(100% - 50px)">
              <el-checkbox-group v-model="checkNodeList">
                <div
                  class="check-content"
                  v-for="item in audioData"
                  :key="item.name"
                >
                  <el-checkbox :label="item.name"></el-checkbox>
                </div>
              </el-checkbox-group>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeAudioDialog">取消</el-button>
        <el-button
          type="primary"
          :disabled="!checkNodeList.length"
          @click="confirmAudioDialog"
          >确认</el-button
        >
      </div>
    </app-panel>
  </div>
</template>
  
  <script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
export default {
  props: {
    deviceTitle: {
      type: String,
      default: "",
    },
    showIntercomList: {
      type: Boolean,
      default: false,
    },
    isType: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      panelPlaceholder: "请输入",
      checkNodeList: [],
      isTransparent: true,
      sourceData: [],
      audioData: [],
      expandedKeys: [],
      filterText: "",
      chooseAudiosCopy: [],
      audioName: "",
      videoData: [],
      gbProps: {
        children: "children",
        label: "name",
        id: "id",
        disabled: (val) => {
          let isCheck = this.$attrs.broadcastArray.some((el) => {
            if (this.$attrs.broadcastPageType == 1) {
              return (
                el.thirdCameraId == val.thirdCameraId && el.checkType == "call"
              );
            }
            if (this.$attrs.broadcastPageType == 2) {
              return (
                el.thirdCameraId == val.thirdCameraId && el.checkType == "audio"
              );
            }
          });
          return val.deviceMark != 26 || isCheck;
        },
      },
      treeProps: {
        label: "name",
        children: "subTreeModelList",
        id: "id",
      },
    };
  },
  components: { appPanel },
  watch: {
    // 话筒查询
    filterText(val) {
      this.$refs.panelDeviceTree.filter(val);
    },
    // 广播查询
    audioName(val) {
      this.filterAudio(val);
    },
    showIntercomList: {
      handler(val) {
        if (val) {
          if (this.isType == 1) {
            // 话筒
            this.getSourceData();
          } else if (this.isType == 3) {
            // 音频
            this.getAudioList();
          } else if (this.isType == 2) {
            // 广播
            this.getDeviceList();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 过滤广播喊话/音频喊话正在使用的设备
    isCheckMap(data) {
      console.log(this.$attrs);
      console.log(data);
      if (data.nodeType == "workgroup") {
        return true;
      } else {
        //
      }
    },
    nodeCheck(info, isCHeck) {
      // console.log(info);
      this.checkNodeList = [...this.$refs.panelDeviceTree.getCheckedNodes()];
    },
    // 节点点击
    nodeClick(data) {
      // console.log(data);
      this.checkNodeList = [{ ...data }];
    },
    // 过滤广播
    filterAudio(val) {
      let tempArr = [];
      if (!val) {
        this.audioData = this.audioDataCopy;
        return;
      }
      this.audioData.forEach((item) => {
        if (item.name.indexOf(val) > -1) {
          tempArr.push(item);
        }
      });
      this.audioData = [...tempArr];
    },
    // 获取音频文件
    getAudioList() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
      };
      this.$fetch(api.queryAudio, params).then((res) => {
        if (res.success) {
          this.audioData = (res.returnObj && res.returnObj.list) || [];
          this.audioDataCopy = [...this.audioData];
        } else {
          this.$message.error(res.msgContent || "查询音频列表失败");
        }
      });
    },
    //过滤话筒
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    // 获取话筒
    getSourceData() {
      const params = {
        // 设备子类型 26-广播（包含广播和麦克风），18-摄像机
        deviceMarkList: [26],
        // 是否需要权限过滤，0：不过滤，1：过滤
        authorityFlag: 1,
      };
      this.$fetch(api.queryAreaDeviceTree, params).then((res) => {
        if (res.success) {
          this.sourceData = res.returnObj || [];
          if (this.sourceData && this.sourceData.length) {
            this.expandedKeys = [this.sourceData[0].id];
            this.$nextTick(() => {
              this.checkNodeList.length &&
                this.$refs.panelDeviceTree.setCurrentKey(
                  this.checkNodeList[0].id
                );
            });
          }
        } else {
          this.$message.error(res.msgContent || "查询源终端列表失败");
        }
      });
    },
    // 获取广播设备
    getDeviceList() {
      this.$fetch(api.queryDeviceWorkGroupDeviceTree, {
        deviceType: 18,
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        } else {
          this.sourceData = res.returnObj;
          this.$nextTick(() => {
            let checkList = this.checkNodeList.map((el) => {
              return el.deviceId;
            });
            this.$refs.panelDeviceTree.setCheckedKeys(checkList);
          });
        }
      });
    },
    closeAudioDialog() {
      this.$refs.panelDeviceTree &&
        this.$refs.panelDeviceTree.setCheckedKeys([]);
      this.checkNodeList = [];
      this.$emit("handleClose");
    },
    confirmAudioDialog() {
      if (this.isType == 1) {
        if (this.checkNodeList[0].deviceType != 26) {
          this.$message.warning("当前选择的不是话筒设备,请重新选择");
          return;
        }
        this.$emit("handleConfirm", this.checkNodeList[0]);
        this.checkNodeList = [];
      }
      if (this.isType == 2 || this.isType == 3) {
        this.$emit("handleConfirmList", this.checkNodeList);
        this.checkNodeList = [];
      }
    },
  },
};
</script>
  <style lang='scss' scoped>
.broadcast-intercom-table {
  height: 100%;
  background: rgba(24, 31, 46, 0.65);
  // padding: 5px 10px;
  .table_search {
    margin-bottom: 16px;
    padding: 0 8px;
  }
  .table_content {
    //  font-size: 20px;
    height: 100%;
    margin-top: 10px;
    .check-content {
      margin: 0 6px;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #353945;
    }
  }
}
.showOverText {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  i {
    color: #3e76e6;
  }
}
.dialog-footer {
  text-align: center !important;
}
</style>